import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import Column from '../../layouts/Column'
import Row from '../../layouts/Row'
import AnimatedLogo from '../AnimatedLogo'
import MainMenu from '../MainMenu'
import PageLink from '../PageLink'
import './styles.scss'

const Header = ({ location, lang, sticky, invertLogo }) => (
  <header className={cx({ header: true, 'is-sticky': sticky })} id="header">
    <div className="header__inner">
      <Row width="fluid" alignItems="center">
        <Column span={6} spanWhen={{ md: 3 }}>
          <PageLink to="/" display="block">
            <AnimatedLogo invert={invertLogo} />
          </PageLink>
        </Column>
        <Column span={6} spanWhen={{ md: 9 }}>
          <MainMenu location={location} lang={lang} />
        </Column>
      </Row>
    </div>
  </header>
)

Header.propTypes = {
  location: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  sticky: PropTypes.bool,
  invertLogo: PropTypes.bool
}

Header.defaultProps = {
  sticky: true,
  invertLogo: false
}

export default Header
